<div>
    <div style="display: flex; justify-content: flex-end; margin-bottom: 2%">
        <button class="noPrint" style="margin-right: 10px;" mat-raised-button color="primary"
            printSectionId="print-section" ngxPrint [useExistingCss]="true">
            Print
        </button>
        <button mat-dialog-close onclick="closeexp()" class="btn btn-secondary noPrint">
            Close
        </button>
    </div>
    <div class="container" id="print-section">
        <div class="wrapper">
            <div class="row rowborder">
                <div class="col-md-4 col-lg-4 text-start" style="font-weight: bold; margin-bottom: 10px;">
                    <div class="ml-3">
                        <span>दिनांक : {{ getFormattedDate() }}</span><br>
                        <span>पृष्ठ क्र : 1</span>
                    </div>
                </div>
                <div class="col-md-4 col-lg-4 text-center" style="font-weight: bold; margin-bottom: 10px;">
                    <div>
                        <span>हिंदुस्थान प्रकाशन संस्था</span><br>
                        <span>विवेक साप्ताहिक</span><br>
                        <span>जर्नल व्हाऊचर नोंदी</span>
                    </div>
                </div>
                <div class="col-md-4 col-lg-4 text-right" style="font-weight: bold; margin-bottom: 10px;">
                    <div class="mr-3">
                        <span>दि. पासून : {{startDate}}</span> <br>
                        <span>दि. पर्यंत : {{endDate}}</span>
                    </div>
                </div>
            </div>
            <ng-container *ngFor="let data of alldebitvoucher">
                <div class="row rowborder hcs" style=" gap: 0;margin-top:16px;">
                    <div class="col-2 common" rowborder>
                        <span>सांकेतांक : {{data.voucher_no}}</span>
                    </div>
                    <div class="col-2 common">
                        <span>दिनांक : {{data.voucher_date}}</span>
                    </div>
                    <div class="col-4 common">
                        <span>तपशील {{data.expenses[0].narration}}</span>
                    </div>

                    <div class="col-2 common">
                        <span>डेबिट</span>
                    </div>
                    <div class="col-2 common">
                        <span>क्रेडिट</span>
                    </div>
                </div>
                <ng-container *ngFor="let data1 of data.expenses">
                    <div class="row rowborder">
                        <div class="col-2">
                            <span></span>
                        </div>
                        <!-- <div class="col-1"></div> -->
                        <div class="col-2">
                            <span>{{data1.exp_name}}</span>
                        </div>
                        <div class="col-4" [ngStyle]="{'padding-left': data1.sub_exp_name === '-' ? '5%' : '0'}">
                            <span>
                                {{data1.sub_exp_name}}
                            </span>
                        </div>
                        <div class="col-2">
                            <span *ngIf="data1.amt_status=='DR'">{{data1.exp_amt}}</span>
                        </div>
                        <div class="col-2">
                            <span *ngIf="data1.amt_status=='CR'">{{data1.exp_amt}}</span>
                        </div>
                    </div>
                </ng-container>

                <div class="row rowborder bcs">
                    <div class="col-2">
                        <span></span>
                    </div>
                    <!-- <div class="col-1"></div> -->
                    <div class="col-2">
                        <span></span>
                    </div>
                    <div class="col-4">
                        <span>नोंदणीची एकूण :</span>
                    </div>
                    <div class="col-2">
                        <span>{{data.total_dr}}</span>
                    </div>
                    <div class="col-2">
                        <span>{{data.total_cr}}</span>
                    </div>

                </div>
            </ng-container>



        </div>
        <print-preview-layout-settings class="settings-section"></print-preview-layout-settings>

    </div>
</div>